var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldedNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 58,
    viewBox: "0 0 65 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6991",
    x: 0,
    y: 0,
    width: 65,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30438",
    "data-name": "Group 30438",
    transform: "translate(-1000.836 -1416.707)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1000.84, 1416.71)",
    filter: "url(#Rectangle_6991)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6991-2",
    "data-name": "Rectangle 6991",
    width: 47,
    height: 40,
    rx: 3,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "content_paste_search_black_24dp",
    transform: "translate(1014.689 1428.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30271",
    "data-name": "Group 30271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8201",
    "data-name": "Rectangle 8201",
    width: 31,
    height: 31,
    transform: "translate(0.146 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30273",
    "data-name": "Group 30273",
    transform: "translate(4 -2.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30272",
    "data-name": "Group 30272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17565",
    "data-name": "Path 17565",
    d: "M5.481,7.14h7.288V9.459h8.916V7.14h7.365v7.674h2.4V7.14a3.126,3.126,0,0,0-3.162-3.07H21.685a4.772,4.772,0,0,0-8.916,0H6.162A3.126,3.126,0,0,0,3,7.14V28.628A3.126,3.126,0,0,0,6.162,31.7h7.9v-3.07H5.481ZM17.227,4.07A1.536,1.536,0,1,1,15.646,5.6,1.563,1.563,0,0,1,17.227,4.07Z",
    transform: "translate(-3 -1)",
    fill: "#f57f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17566",
    "data-name": "Path 17566",
    d: "M25,22.809a7.542,7.542,0,0,0,1.1-3.759A7.049,7.049,0,1,0,19.049,26.1,7.542,7.542,0,0,0,22.809,25l4.229,4.229,2.193-2.193Zm-5.953.157a3.916,3.916,0,1,1,3.916-3.916A3.878,3.878,0,0,1,19.049,22.965Z",
    transform: "translate(1.223 3.467)",
    fill: "#f57f20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldedNewIcon);
export default __webpack_public_path__ + "static/media/fielded-new-icon.975dda806d6a5dcb35ad3d73272629bf.svg";
export { ForwardRef as ReactComponent };